var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function updateCart() {
  $.get("/").then((data) => {
    // Update drawer
    var cartUpdateSelector = "#cart__drawer";
    var $newCartObj = $($.parseHTML("<div>" + data + "</div>")).find(
      cartUpdateSelector
    );
    $(cartUpdateSelector).replaceWith($newCartObj[0]);
    registerCartEvents();

    // Update header (& cart if on cart)
    var cartUpdateSelector =
      '#site-control .cart:not(.nav-search), [data-section-type="cart-template"]';
    var $newCartObj = $($.parseHTML("<div>" + data + "</div>")).find(
      cartUpdateSelector
    );
    $(cartUpdateSelector).each(function (index) {
      $($newCartObj[index])
        .find("[data-cc-animate]")
        .removeAttr("data-cc-animate");
      $(this).replaceWith($newCartObj[index]);
      $(this).parent().find("[data-cc-animate]").removeAttr("data-cc-animate");
    });
  });
}

function registerCartEvents() {
  const lineItems = document.querySelectorAll(".cart-list .item");

  lineItems.forEach((item, i) => {
    const quantityDecrease = item.querySelector(".js-quantity-decrease");
    const quantityIncrease = item.querySelector(".js-quantity-increase");
    const remove = item.querySelector(".js-remove");

    remove.addEventListener("click", (e) => {
      e.preventDefault();
      const index = quantityDecrease.getAttribute("data-index");

      $.get(`/cart/change?line=${index}&quantity=0`, function (itemData) {
        $.get("/cart", function (data) {
          updateCart();
        });
      });
    });

    quantityDecrease.addEventListener("click", (e) => {
      e.preventDefault();
      const quantityInput = item.querySelector(".quantity > input");
      const index = quantityDecrease.getAttribute("data-index");
      const quantity = Number(quantityInput.value);
      if (quantity == 1) return;

      $.get(
        `/cart/change?line=${index}&quantity=${quantity - 1}`,
        function (itemData) {
          quantityInput.value = quantity - 1;
          updateCart();
        }
      );
    });

    quantityIncrease.addEventListener("click", (e) => {
      e.preventDefault();
      const quantityInput = item.querySelector(".quantity > input");
      const index = quantityDecrease.getAttribute("data-index");
      const quantity = Number(quantityInput.value);

      $.get(
        `/cart/change?line=${index}&quantity=${quantity + 1}`,
        function (itemData) {
          quantityInput.value = quantity + 1;
          updateCart();
        }
      );
    });
  });
}

function registerUpsellEvents() {
  const upsellAddToCartButtons = document.querySelectorAll(
    ".strap-suggestion .strap-suggestion-button, .strap-suggestion .strap-suggestion-button-mobile"
  );

  upsellAddToCartButtons.forEach((button, i) => {
    button.addEventListener("click", (e) => {
      const variantId = button
        .closest(".strap-suggestion")
        ?.getAttribute("data-variant-id");

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      $.ajax({
        url: "/cart/add.js",
        type: "post",
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
          updateCart();
          document.querySelector(".nav-right-side > a.cart-action")?.click();
        },
      });
    });
  });

  const colorSwatches = document.querySelectorAll(
    ".strap-suggestion .strap-upsell-selector-desktop .swatch-color"
  );

  colorSwatches.forEach((swatch, i) => {
    swatch.addEventListener("click", (e) => {
      swatch
        .closest(".strap-suggestion")
        .querySelectorAll(".swatch-color")
        .forEach((_) => _.classList.remove("selected"));
      swatch.classList.add("selected");

      const variantId = swatch.getAttribute("data-variant-id");
      const featuredImage = swatch.getAttribute("data-featured-image");
      const secondImage = swatch.getAttribute("data-second-image");
      const displayName = swatch.getAttribute("data-display-name");
      const price = swatch.getAttribute("data-price");
      const productLink = swatch.getAttribute("data-product-link");

      swatch
        .closest(".strap-suggestion")
        .setAttribute("data-variant-id", variantId);
      swatch
        .closest(".strap-suggestion")
        .querySelector(".strap-suggestion-image > .strap-featured-img").src =
        featuredImage;
      swatch
        .closest(".strap-suggestion")
        .querySelector(".strap-suggestion-image > .strap-second-img").src =
        secondImage;
      swatch.closest(".strap-suggestion").querySelector(".price").innerHTML =
        price;
      swatch
        .closest(".strap-suggestion")
        .querySelector(
          ".strap-suggestion-content .color-title > span"
        ).innerHTML = displayName;
      swatch
        .closest(".strap-suggestion")
        .querySelector(".strap-suggestion-content a").href = productLink;
      swatch
        .closest(".strap-suggestion")
        .querySelector(".strap-suggestion-image").href = productLink;
    });
  });

  const colorDropdowns = document.querySelectorAll(
    ".strap-suggestion .strap-suggestion-content .strap-upsell-dropdown"
  );
  const mobileAddToCartButtons = document.querySelectorAll(
    ".strap-suggestion .strap-suggestion-button-mobile"
  );

  colorDropdowns.forEach((dropdown, i) => {
    dropdown.addEventListener("click", (e) => {
      if (dropdown.classList.contains("active")) {
        dropdown.classList.remove("active");
        dropdown.querySelector(".dropdown-content").classList.remove("show");
        mobileAddToCartButtons[i].classList.remove("is-hidden");
        return;
      }
      colorDropdowns.forEach((colorDropdown, i) => {
        colorDropdown.classList.remove("active");
        colorDropdown
          .querySelector(".dropdown-content")
          .classList.remove("show");
        mobileAddToCartButtons[i].classList.remove("is-hidden");
      });
      dropdown.classList.toggle("active");
      dropdown.querySelector(".dropdown-content").classList.toggle("show");
      mobileAddToCartButtons[i].classList.toggle("is-hidden");
    });
  });

  // Close the dropdown if the user clicks outside of it
  window.onclick = function (event) {
    if (
      !event.target.matches(".strap-upsell-dropbtn, .strap-upsell-dropbtn *")
    ) {
      colorDropdowns.forEach((dropdown, i) => {
        dropdown.classList.remove("active");
        dropdown.querySelector(".dropdown-content").classList.remove("show");
        mobileAddToCartButtons[i].classList.remove("is-hidden");
      });
    }
  };

  const colorOptions = document.querySelectorAll(
    ".strap-suggestion .strap-suggestion-content .strap-upsell-dropdown .dropdown-content .dropdown-content-container"
  );

  colorOptions.forEach((option, i) => {
    option.addEventListener("click", (e) => {
      option
        .closest(".strap-suggestion")
        .querySelectorAll(".dropdown-content-container")
        .forEach((_) => _.classList.remove("selected"));
      option.classList.add("selected");

      const variantId = option.getAttribute("data-variant-id");
      const featuredImage = option.getAttribute("data-featured-image");
      const secondImage = option.getAttribute("data-second-image");
      const dropdownTitle = option.innerHTML;
      const price = option.getAttribute("data-price");
      const productLink = option.getAttribute("data-product-link");

      option
        .closest(".strap-suggestion")
        .setAttribute("data-variant-id", variantId);
      option
        .closest(".strap-suggestion")
        .querySelector(".strap-suggestion-image > .strap-featured-img").src =
        featuredImage;
      option
        .closest(".strap-suggestion")
        .querySelector(".strap-suggestion-image > .strap-second-img").src =
        secondImage;
      option
        .closest(".strap-suggestion")
        .querySelector(".price-mobile").innerHTML = price;
      option
        .closest(".strap-suggestion")
        .querySelector(
          ".strap-suggestion-content .strap-upsell-dropbtn .strap-upsell-dropdown-title"
        ).innerHTML = dropdownTitle;
      option
        .closest(".strap-suggestion")
        .querySelector(".strap-suggestion-content a").href = productLink;
      option
        .closest(".strap-suggestion")
        .querySelector(".strap-suggestion-image").href = productLink;
    });
  });
}

$(document).ready(function () {
  registerCartEvents();
  registerUpsellEvents();
});
